module.exports = __webpack_public_path__ + "img/left.cb56fc4a.svg";